import { Reveal } from "./Motion";
import { useLang } from "@/lib/i18n";

const PHOTOS = [
  { src: "https://images.pexels.com/photos/8535230/pexels-photo-8535230.jpeg?auto=compress&cs=tinysrgb&w=1200", capKey: "life.cap.1", span: "col-span-12 md:col-span-8 aspect-[4/3]" },
  { src: "https://images.pexels.com/photos/8617715/pexels-photo-8617715.jpeg?auto=compress&cs=tinysrgb&w=1000", capKey: "life.cap.2", span: "col-span-6 md:col-span-4 aspect-[4/5]" },
  { src: "https://images.pexels.com/photos/8613089/pexels-photo-8613089.jpeg?auto=compress&cs=tinysrgb&w=1000", capKey: "life.cap.3", span: "col-span-6 md:col-span-4 aspect-square" },
  { src: "https://images.pexels.com/photos/8613319/pexels-photo-8613319.jpeg?auto=compress&cs=tinysrgb&w=1000", capKey: "life.cap.4", span: "col-span-6 md:col-span-4 aspect-square" },
  { src: "https://images.pexels.com/photos/7147434/pexels-photo-7147434.jpeg?auto=compress&cs=tinysrgb&w=1000", capKey: "life.cap.5", span: "col-span-12 md:col-span-4 aspect-square" },
];

export default function LifeAt() {
  const { t } = useLang();
  return (
    <section id="la-vie" className="py-16 md:py-24 bg-background" data-testid="life-section">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
            <div className="max-w-2xl">
              <div className="chip">{t("life.chip")}</div>
              <h2 className="mt-4 font-heading text-3xl md:text-5xl leading-[1.05]">
                {t("life.title_1")} <span className="text-primary">{t("life.title_at")}</span>
              </h2>
              <p className="mt-4 text-lg text-foreground/75 leading-relaxed">{t("life.subtitle")}</p>
            </div>
            <p className="text-xs text-foreground/50 md:text-right md:max-w-[220px] leading-relaxed">
              {t("life.note")}
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-12 gap-4 md:gap-6" data-testid="life-grid">
          {PHOTOS.map((p, i) => (
            <Reveal key={p.src} delay={i * 0.05} className={p.span}>
              <figure className="h-full">
                <div className="relative w-full h-full overflow-hidden rounded-3xl group">
                  <img
                    src={p.src}
                    alt={t(p.capKey)}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                  />
                </div>
                <figcaption className="mt-3 text-sm text-foreground/70 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary" />
                  {t(p.capKey)}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
